import { render, staticRenderFns } from "./TasksLogs.vue?vue&type=template&id=a804ca48&scoped=true&"
import script from "./TasksLogs.vue?vue&type=script&lang=js&"
export * from "./TasksLogs.vue?vue&type=script&lang=js&"
import style0 from "./TasksLogs.vue?vue&type=style&index=0&id=a804ca48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a804ca48",
  null
  
)

export default component.exports